import React, { useState, useEffect } from "react";
import { order_page_labels } from "../../Constants/Labels";
import moment from "moment";
import { available_send_dates } from "../../Constants/constants";

const ExportForFulfillment = ({ store,storeName, user, status, setOnOrderExportLoading, setErrors, setPopup }) => {
    const [mode, setMode] = useState(order_page_labels.orders.fulfillment.fulfillment_mode[0])
    const [selectedDate, setSelectedDate] = useState(available_send_dates[0]?.send_date)
    const [error_message, setErrorMessage]= useState(" ")

    const cardType = [
        {
            name: "Personalized card",
            value: "PERSONALIZED-CRD"
        },
        {
            name: "Blank card",
            value: "BLANK-CRD"
        }]
    const [selectedCardTypes,setSelectedCardTypes]=useState(['PERSONALIZED-CRD',"BLANK-CRD"])
    // const [selectedCardTypes,setSelectedCardTypes]=useState(["BLANK-CRD"])


    useEffect(()=>{
        if(error_message!=" "){
        setTimeout(()=>{
            setErrorMessage(" ")
        },5000)
    }
    },[error_message])

    function selectDate(value) {
        setMode(value)
    }

    console.log("kkk",storeName);

    const AddOrRemoveTypes=(value)=>{
        if(selectedCardTypes.includes(value)&&selectedCardTypes.length>1){
            setSelectedCardTypes(selectedCardTypes.filter(a=>a!==value))
        }
        else if(!selectedCardTypes.includes(value)){
            setSelectedCardTypes([...selectedCardTypes,value])
        }
    }


    const exportData = () => {
        var pay_load = {
            "store_id": parseInt(store?.id),
            "status": order_page_labels?.orders?.status[status],
            "export_format": "Fulfillment",
            "card_types":selectedCardTypes,
            "store_name": storeName
        }

        var max_date = moment(available_send_dates.find(a => a.send_date === selectedDate)?.drop_date, 'MMM-DD-yyyy').format('YYYY-MM-DD')
        var min_date = moment(available_send_dates[available_send_dates.findIndex(a => a.send_date === selectedDate) - 1]?.drop_date, 'MMM-DD-yyyy').format('YYYY-MM-DD')
            pay_load.send_date = {
                requested_send_date: moment(selectedDate, 'MMM-DD-YYYY').format('YYYY-MM-DD'),
                max_date: max_date,
                isPDF:mode === order_page_labels.orders.fulfillment.fulfillment_mode[1]
            }
            if (available_send_dates.findIndex(a => a.send_date == selectedDate) > 0) {
                pay_load.send_date.min_date = min_date
            } else {
                var date = new Date(max_date).setDate(new Date(max_date).getDate() - 60)
                pay_load.send_date.min_date = moment(new Date(date)).format("YYYY-MM-DD")
            }
        // }

        var export_file_name = "fulfillment_export.xlsx"

        console.log("pay_load" + JSON.stringify(pay_load))
        var baseUrl = process.env.REACT_APP_DEV_BASE_URL
        setOnOrderExportLoading(true)
        // if(!error){
        fetch(baseUrl + '/admin/data/export-orders',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': user?.auth_token
                },
                body: JSON.stringify(pay_load)
            })
            .then(async data => {
                
                        setOnOrderExportLoading(false)
                console.log("dta",data);
                const contentType = data.headers.get("content-type");

                if (contentType && contentType.includes("application/json")) {
                    // API returned JSON (likely error/info)
                    const data = await data.json();
                    if (data.errors) {
                        setErrors(data.errors);
                    } else {
                        setErrors(["Unexpected JSON response"]);
                    }
                    setPopup('')
                } else {
                    data.blob().then(blob => {
                        // blob.text().then( text => console.log(text))
                        
                        const fileSize = blob.size
                        console.log(fileSize,"filesss",fileSize > 500);
                        if (fileSize > 0) {
                            // Creating new object of PDF file
                            const fileURL = window.URL.createObjectURL(blob);
                            // Setting various property values
                            let alink = document.createElement('a');
                            alink.href = fileURL;
                            alink.download = export_file_name
                            alink.click();
                            setPopup('')
                        } else {
                            setErrors(["No record found"])
                            setErrorMessage("There are no orders to export")
                        }
                    })
                }
            })
    }

    return (
        <div className="w-100">
            <div className="fulfillment_wrapper">
                <div>
                    {store?.sub_domain=='glwd' &&<div>
                        <h5 className=" m-0">Product Type</h5>
                        <div className="d-flex">
                        {cardType.map((type, index) => {
                            return (
                                <div key={index} className="d-flex">
                                    <input type="checkbox" disabled={store?.sub_domain!='glwd'} checked={selectedCardTypes.includes(type.value)} className="ml-5 m-0" onClick={()=>{AddOrRemoveTypes(type.value)}} />
                                    <p className=" px-3" style={{ paddingTop: 7 }}>{type.name}</p>
                                </div>
                            )
                        })
                        }
                        </div>
                        <span className="mandatory_field"></span><span className="p-2 noteContent ">Note : Minimum one type should be selected</span>
                    </div>}
                    <div>
                        <h5 className=" m-0">Generate</h5>
                        {order_page_labels.orders.fulfillment.fulfillment_mode.map((fulfillment, index) => {
                            return (
                                <div key={index} className="d-flex">
                                    <input type="radio" checked={mode == fulfillment} disabled={!selectedCardTypes.includes('PERSONALIZED-CRD')&&fulfillment.includes('PDF')} className="ml-5 m-0" onChange={() => { index == 1 ? selectDate(fulfillment) : setMode(fulfillment) }} />
                                    <p className="px-3" style={{ paddingTop: 7 }}>{fulfillment}</p>
                                </div>
                            )
                        })
                        }
                    </div>
                    <div>
                        <h5 className="mt-3">Filter</h5>
                        <div className="d-flex">
                            <h6 className=" mt-3 mx-5 text-nowrap ">
                                {/* Date Range */}
                                Shipping Date
                                </h6>
                            <div className="">
                                <select className='form-control' style={{ width: "200px" }} disabled={available_send_dates.length == 0} value={selectedDate ? moment(selectedDate).format("MMM-DD-YYYY") : ""} onChange={(e) => setSelectedDate(e.target.value)} >
                                    {/* {order_page_labels.orders.fulfillment.fulfillment_mode[0] == mode && <option value={'custom date'}>Custom Date Range </option>} */}
                                    {available_send_dates.map((date, index) => {
                                        return (
                                            <option key={index} value={date.send_date}>
                                                {/* For Shipping Date  */}
                                                {date.send_date}
                                            </option>
                                        )
                                    })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="error-message mt-3">{error_message}</div>
                    <div className="d-flex justify-content-center mt-3">
                        <button onClick={exportData} className="btn btn-primary ">Generate</button>
                    </div>
                </div>
            </div>
        </div>
    )

}
export default ExportForFulfillment;